var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18155",
    "data-name": "Group 18155",
    transform: "translate(-199 -437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16485",
    "data-name": "Path 16485",
    d: "M27.844,15.414a6.026,6.026,0,0,1,5.689,6.632,6.013,6.013,0,0,1-5.764,5.007A6.029,6.029,0,0,1,22.04,20.2a5.962,5.962,0,0,1,5.654-4.79Zm-.127,1.809a4.157,4.157,0,0,0-3.563,5.748,4.177,4.177,0,0,0,6.381,1.166c2.193-2.091,1.033-6.842-2.714-6.913Zm.142,11.037A9.834,9.834,0,0,1,36.452,33.7.939.939,0,0,1,35.337,35c-.573-.228-.729-.982-1.1-1.518A8.078,8.078,0,0,0,23.76,31.172a7.98,7.98,0,0,0-3.078,3.383,1.132,1.132,0,0,1-.772.512c-.709.034-1.159-.748-.671-1.67A9.832,9.832,0,0,1,27.859,28.26Z",
    transform: "translate(185.307 424.611)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8934",
    "data-name": "Rectangle 8934",
    width: 28,
    height: 26,
    transform: "translate(199 437)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.adaa3adce12dc819cd13ea5cfcfbba85.svg";
export { ForwardRef as ReactComponent };